import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { HiringResourcesEffects } from './store/hiring-resources.effects';
import { HiringResourcesNamespace, HiringResourcesReducer } from './store/hiring-resources.store';

const provideHiringResourcesState = provideState(HiringResourcesNamespace, HiringResourcesReducer);
const provideHiringResourcesEffects = provideEffects(HiringResourcesEffects);

export const hiringResourcesData = [provideHiringResourcesState, provideHiringResourcesEffects];
